export const DEFAULT_HISTORY_BUTTON_LABEL = 'See Change History';
